import { AddressSummaryFormIN } from '@/components/slides/DataSummary/in/SummaryForms/AddressSummaryFormIN';
import { AncestrySummaryFormIN } from '@/components/slides/DataSummary/in/SummaryForms/AncestrySummaryFormIN';
import { ContactSummaryFormIN } from '@/components/slides/DataSummary/in/SummaryForms/ContactSummaryFormIN';
import { NameSummaryFormIN } from '@/components/slides/DataSummary/in/SummaryForms/NameSummaryFormIN';
import { PersonalInfoSummaryFormIN } from '@/components/slides/DataSummary/in/SummaryForms/PersonalInfoSummaryFormIN';
import { ContactPersonSummaryFormIN } from '@/components/slides/DataSummary/in/SummaryForms/ContactPersonSummaryFormIN';
import { SecondContactPersonSummaryFormIN } from '@/components/slides/DataSummary/in/SummaryForms/SecondContactPersonSummaryFormIN';

export const SummaryFormsIN = () => {
  return (
    <>
      <NameSummaryFormIN />
      <ContactSummaryFormIN />
      <AddressSummaryFormIN />
      <PersonalInfoSummaryFormIN />
      <AncestrySummaryFormIN />
      <ContactPersonSummaryFormIN />
      <SecondContactPersonSummaryFormIN />
    </>
  );
};
